import { render, staticRenderFns } from "./NCheckbox.vue?vue&type=template&id=c020f600"
import script from "./NCheckbox.vue?vue&type=script&lang=js"
export * from "./NCheckbox.vue?vue&type=script&lang=js"
import style0 from "./NCheckbox.vue?vue&type=style&index=0&id=c020f600&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports